import { PropsWithChildren } from 'react';

export const CalculatorModalTopSection = ({ children }: PropsWithChildren) => (
    <div>
        {children}
    </div>
);
